import { useTranslation } from 'react-i18next';
import UserGroupAddCard from '../../../User/UserGroupAddCard';
import CircularLoader from '../../../../../components/CircularLoader/CircularLoader';
import Styles from '../GroupInfoModal.module.css';
import AddGroupUsersStyles from '../../AddGroupUsersModal/AddGroupUsersMoal.module.css';

const AddUserSearchResult = ({ loading, addUser, addUserSearchResults, handleCheckboxChange, cardListRef2, circularLoader }) => {
  const { t } = useTranslation();
  return addUserSearchResults && addUserSearchResults.length > 0 ? (
    <div className={Styles.cardList} ref={cardListRef2} style={{ height: '280px' }}>
      {addUserSearchResults && addUserSearchResults.length > 0 ? (
        addUserSearchResults?.map(item => (
          <UserGroupAddCard key={item._id} name={item.name} id={item._id} email={item.email} handleCheckboxToggle={handleCheckboxChange} />
        ))
      ) : (
        <div>
          {!loading && (
            <div className={AddGroupUsersStyles.emptyList}>
              <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#cbd5e1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
                <circle cx='9' cy='7' r='4' />
              </svg>
              <span>{t('screens.chat.noUsersFound')}</span>
            </div>
          )}
        </div>
      )}
      {addUserSearchResults && addUserSearchResults.length > 0 && circularLoader && (
        <div className={Styles.circularLoader}>
          <CircularLoader />
        </div>
      )}
    </div>
  ) : (
    <div>
      {!loading && (
        <div className={AddGroupUsersStyles.emptyList}>
          <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#cbd5e1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
            <circle cx='9' cy='7' r='4' />
          </svg>
          <span>No Users Found</span>
        </div>
      )}
    </div>
  );
};

export default AddUserSearchResult;
